import { faMessage, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Button, Input, Select } from 'antd';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';
import MessagesFilter from './components/MessagesFilter';
import MessagesList from './components/MessagesList';
import PersonalDataContainer from './components/PersonalDataContainer';
import { Filter } from './components/MessagesFilter';
import { useEffect, useState } from 'react';
import { CreateMessageMutation, GetMessageQuery, Message, MessageCategory, MessageInput } from '../../API';
import { GraphQLResult, GRAPHQL_AUTH_MODE } from '@aws-amplify/api-graphql';
import { API } from 'aws-amplify';
import { getMessage } from '../../graphql/queries';
import { createMessage } from '../../graphql/mutations';
import { useDispatch } from 'react-redux';
import { openSidebar } from '../../features/theme/themeSlice';

const { TextArea } = Input;
const { Option } = Select;
const aCategories = Object.values(MessageCategory);

const MessagesForm: React.FC = () => {
	const [filter, setFilter] = useState<Filter | null>(null);
	const [refreshData, setRefreshData] = useState<boolean>(false);
	const [activeMessage, setActiveMessage] = useState<Message | null>(null);
	const [updateCounter, setUpdateCounter] = useState<boolean>(false);
	const [newMessage, setNewMessage] = useState<boolean>(false);
	const [replyMessage, setReplyMessage] = useState<boolean>(false);
	const [newMessageText, setNewMessageText] = useState<string>('');
	const [newMessageSubject, setNewMessageSubject] = useState<string>('');
	const [newMessageCategory, setNewMessageCategory] = useState<string>('');
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(openSidebar(false));
	}, []);
	return (
		<PersonalDataContainer header title={<FormattedMessage id="personal.data.messaggi.title" />}>
			<Alert type="info" message={<FormattedMessage id="messages.form.title" />} />
			<div className="d-flex f-row mt-1 ">
				<div className="d-flex f-column messages-list mr-2">
					<MessagesFilter
						updateCounter={updateCounter}
						onFilter={f => {
							setFilter(f);
						}}
						onRefresh={() => {
							setFilter(null);
							setRefreshData(!refreshData);
						}}
						onNewMessageClick={() => {
							setActiveMessage(null);
							setNewMessage(true);
							setReplyMessage(false);
						}}
					/>
					<MessagesList
						filter={filter}
						refreshData={refreshData}
						onMessageClick={m => {
							const messageFields: Array<string> = m.SK.split('#');
							const PK = ''.concat(messageFields[2], '#', messageFields[3]);
							const SK = ''.concat(messageFields[0], '#', messageFields[1]);
							(async () => {
								const result: GraphQLResult<GetMessageQuery> = (await API.graphql({
									query: getMessage,
									authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
									variables: { SK: SK, PK: PK, readed: m.readed }
								})) as GraphQLResult<GetMessageQuery>;
								setNewMessage(false);
								setReplyMessage(true);
								setUpdateCounter(!updateCounter);

								setActiveMessage(result.data.getMessage);
							})();
						}}
					/>
				</div>
				<div className="d-fles f-column messages-detail">
					<div className="d-flex f-column message-detail-container">
						{activeMessage && (
							<>
								<div className="text-header">{activeMessage.messageSubject}</div>
								<div className="text-container">{activeMessage.messageText}</div>
								<div className="text-created-at">
									<FormattedDate value={activeMessage.createdAt} /> |
									<FormattedTime value={activeMessage.createdAt} />
								</div>
							</>
						)}

						<div className="new-message">
							{newMessage && (
								<>
									<label>
										<FormattedMessage id="category" />
									</label>
									<Select
										style={{ width: '100%' }}
										className="mb-1 "
										onChange={v => {
											setNewMessageCategory(v);
										}}
										value={newMessageCategory}
									>
										<Option value="">{''}</Option>
										{aCategories.map((c, i) => {
											return (
												<Option key={`opt-${i}`} value={c}>
													<FormattedMessage id={c} />
												</Option>
											);
										})}
									</Select>
									<label>
										<FormattedMessage id="subject" />
									</label>
									<Input
										className="mb-1"
										value={newMessageSubject}
										onChange={evt => setNewMessageSubject(evt.target.value)}
									/>
									<label>
										<FormattedMessage id="message" />
									</label>
								</>
							)}

							{(newMessage || replyMessage) && (
								<>
									<TextArea
										value={newMessageText}
										onChange={evt => {
											setNewMessageText(evt.target.value);
										}}
									/>

									<div className="new-message-btn-container">
										<Button
											type="primary"
											className="new-message-btn ant-btn-secondary"
											onClick={() => {
												const mInput: MessageInput = {
													messageSubject: newMessageSubject,
													messageCategory: MessageCategory.INFO,
													messageText: newMessageText
												};
												if (newMessage) {
													const category: MessageCategory = newMessageCategory as any;
													mInput.messageSubject = newMessageSubject;
													mInput.messageCategory = MessageCategory[category];
													mInput.messageText = newMessageText;
												} else {
													const category: MessageCategory =
														activeMessage.messageCategory as any;
													mInput.messageSubject = activeMessage.messageSubject;
													mInput.messageCategory = MessageCategory[category];
													mInput.messageText = newMessageText;
												}

												(async () => {
													(await API.graphql({
														query: createMessage,
														authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
														variables: { input: mInput, to: 'SYSTEM' }
													})) as GraphQLResult<CreateMessageMutation>;

													setNewMessage(false);
													setReplyMessage(false);
												})();
											}}
										>
											<FontAwesomeIcon icon={faPaperPlane} />
											&nbsp;Invia
										</Button>
									</div>
								</>
							)}
						</div>
					</div>
				</div>
			</div>
		</PersonalDataContainer>
	);
};

export default MessagesForm;
